import { newCOLORS } from '../../styles/colors';

/**
 * Clamps a health score to a valid range (0-100) and handles invalid values
 *
 * @param {number} health The raw health score value
 * @returns {number} A clamped health score between 0 and 100
 */
function clampHealth(health: number): number {
  return Number.isFinite(health) ? Math.min(Math.max(health, 0), 100) : 0;
}

/**
 * Gets the appropriate indicator color based on health score
 *
 * @param {number} score The health score (0-100)
 * @returns {string} The hex color string for the indicator
 */
function getHealthIndicatorColor(score: number): string {
  if (!Number.isFinite(score) || score <= 0) return newCOLORS.gray4;
  if (score >= 80) return newCOLORS.green2;
  if (score >= 60) return newCOLORS.yellow2;
  if (score >= 40) return newCOLORS.orange2;
  return newCOLORS.red2;
}

export { clampHealth, getHealthIndicatorColor };
